export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/tds-vds-rate-list/:pageId',
        component: () => import('@/views/page/company/procurement/tds-vds/tdsVdsList'),
        name: 'tds-vds-rate-list',
        meta: {
            requiresAuth: true
        }
    },
]